<h1 mat-dialog-title>Person View</h1>
<div mat-dialog-content>
  <app-person-view [person]="person$"></app-person-view>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</div>